// Returns the display text for a wizard step (label + optional hint on next line)
export const stepLabel = (step) =>
  step.hint ? `${step.label}\n_\u{1f4a1} ${step.hint}_` : step.label

// ─── Schedule assignment wizard step definitions ───────────────────────────

export const SCHEDULE_EMP_STEPS = [
  {
    key: 'employee_id',
    label: 'Employee ID (e.g. EMP001):',
    hint: "The employee's unique ID that appears on their profile (e.g. EMP001).",
  },
  {
    key: 'shift',
    label: 'Shift name:',
    hint: 'Select a shift from the buttons below, or type its exact name.',
  },
  {
    key: 'start_date',
    label: 'Start Date (YYYY-MM-DD):',
    hint: 'The first day this schedule is active (e.g. 2026-06-01).',
  },
  {
    key: 'end_date',
    label: 'End Date (YYYY-MM-DD):',
    hint: 'The last day this schedule is active (e.g. 2026-12-31).',
  },
]

export const SCHEDULE_BRANCH_STEPS = [
  {
    key: 'branch',
    label: 'Branch / Department name:',
    hint: 'The exact department or branch name (e.g. IT Department, Sales).',
  },
  {
    key: 'shift',
    label: 'Shift name:',
    hint: 'Select a shift from the buttons below, or type its exact name.',
  },
  {
    key: 'start_date',
    label: 'Start Date (YYYY-MM-DD):',
    hint: 'The first day this schedule is active (e.g. 2026-06-01).',
  },
  {
    key: 'end_date',
    label: 'End Date (YYYY-MM-DD):',
    hint: 'The last day this schedule is active (e.g. 2026-12-31).',
  },
]
